/**
 * Optional Search Console / analytics hooks.
 * Scripts load only when corresponding VITE_* IDs are present at build time.
 * No fake tokens. No analytics without a configured ID.
 */
import { useEffect } from 'react'

function metaContent(name: string): string | undefined {
  const raw = (import.meta.env[name] as string | undefined)?.trim()
  return raw || undefined
}

export function AnalyticsBootstrap() {
  useEffect(() => {
    const gsc = metaContent('VITE_GSC_VERIFICATION')
    if (gsc) {
      let el = document.querySelector<HTMLMetaElement>('meta[name="google-site-verification"]')
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', 'google-site-verification')
        document.head.appendChild(el)
      }
      el.setAttribute('content', gsc)
    }

    const bing = metaContent('VITE_BING_VERIFICATION')
    if (bing) {
      let el = document.querySelector<HTMLMetaElement>('meta[name="msvalidate.01"]')
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', 'msvalidate.01')
        document.head.appendChild(el)
      }
      el.setAttribute('content', bing)
    }

    const ga4 = metaContent('VITE_GA4_MEASUREMENT_ID')
    if (ga4 && /^G-[A-Z0-9]+$/i.test(ga4)) {
      const consentOk = document.cookie.includes('pp_analytics=1')
      if (!consentOk) return
      const s = document.createElement('script')
      s.async = true
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4)}`
      document.head.appendChild(s)
      const inline = document.createElement('script')
      inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga4}',{anonymize_ip:true});`
      document.head.appendChild(inline)
    }
  }, [])

  return null
}
